import React, {useEffect, useState } from "react";
import Button from "../../components/common/Button";
import Input from "../../components/common/Input";
import Radio from "../../components/common/Radio";
import Jumpbotron from "../../components/common/Jumpbotron";
import Select from "../../components/common/Select";
import Modal from "../../components/common/Modal";
import DatosProveedor from "../../components/common/DatosProveedor";
import Tab from "../../components/common/Tab";
import { useDispatch } from "react-redux";
import { initDataProveedorContactoRimac_Ex,initDataProveedorContactoRimacArray_Ex,
        initDataProveedorContactoRimac_Val,initDataProveedorContactoRimacArray_Val } from "../../utils/options";
import CustomTable from "../../components/CustomTable";
import TableRimac from "../../components/common/Table/TableRimac";
import { hideLoading, showLoading } from "../../redux/actions/general";
import { headDataUsers } from "../../components/CustomTable/headData";
import usersData from "../../components/CustomTable/usersData";
import addUserIcon from "../../assets/icon_add_user.svg";
import deleteLogo from "../../assets/gl_delete-20.svg";
import "./styles.scss";
import { Checkbox } from "aws-amplify-react";
import { callService } from "../../amplify/callService";
import { CONSTANTES } from "../../utils/Constantes";
import Alert from "../../components/common/Alert";
import { getColorByStatusFlag } from "../../utils/utils";
import { iconEdit, iconCheck } from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import Pagination from "../../components/common/Pagination";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import Validate from "../../utils/Validate";

const ProveedoresContactoRimac = ({dataT, keyIndex, handleActualizarFicha, setActiveTab, handleChangePaso}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);
  const [tagBody, setTagBody] = useState("nostate");  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });
  const [arrPerfiles, setArrPerfiles] = useState([]);
  const [arrPais, setArrPais] = useState([]);
  const [arrDepartamento, setarrDepartamento] = useState([]);
  const [arrProvincia, setArrProvincia] = useState([]);
  const [arrDistrito, setArrDistrito] = useState([]);
  const [arrTipoDoc, SetArrTipoDoc] = useState([]);
  const [arrArea, setArrArea] = useState([]);
  const [data, setData] = useState(Validate.extraerAtributos(initDataProveedorContactoRimac_Ex, dataT, initDataProveedorContactoRimacArray_Ex));
  const [validacion, setValidacion] = useState({contactoRimac:[]});
  useEffect(() => {    
    setData(Validate.extraerAtributos(initDataProveedorContactoRimac_Ex, dataT, initDataProveedorContactoRimacArray_Ex));
  }, [dataT]);
  useEffect(() => {
    getAreas();
  }, []);

  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };
  
  const resetForm =() => {
    
  };
  const getAreas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','AREA_PROV'));
      if (response.ok && response.data && response.data.payload) {
        let areas = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrArea(areas);
      }
    } catch (ex) {
      console.log("Error al obtener getMonedas", ex);
    }
  };

  const handleChange = (name, value, i) => {
    let jsonAd = {};    
    value = value.toUpperCase ? value.toUpperCase() : value;
    setData({ ...data, [name]: value });
    if(value instanceof Array){
      validacion[name][i]=false;
      setValidacion({ ...validacion, [name]: validacion[name]});
    }else{
      setValidacion({ ...validacion, [name]: false });
    }
    
  };
  const validarFormulario = () => {
    let resp = true;
    for (var name in Object.assign({},initDataProveedorContactoRimac_Val,Validate.limpiarObjeto(data))) {
      //if (data.hasOwnProperty(name)){
        if(!data[name] ){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
          //break;
        }
        if(data[name] instanceof Array){
          let limpArr = Validate.limpiarArregloIdProveedor(data[name]);
          data[name] = limpArr.arr;
          if(!data[name][0]){
            if(!data[name][1]){
              if(data[name][2]){
                ((data[name])[0])={};
                ((data[name])[1])={};
                ((validacion[name])[0])={};
                ((validacion[name])[1])={};
              }
            }else{
              ((data[name])[0])={};
              ((validacion[name])[0])={};
            }
          }else{
            if(!data[name][1]){
              if(data[name][2]){
                ((data[name])[1])={};
                ((validacion[name])[1])={};
              }
            }
          }
          if(limpArr.delete.length>0)
            data[name+'Delete'] = limpArr.delete;
          let i=0;
          for(let elem of data[name]){
            for (var name2 in Object.assign({},initDataProveedorContactoRimacArray_Val,Validate.limpiarObjeto(elem))) {
              //if (elem.hasOwnProperty(name2)){
                if(!elem[name2]){
                  console.log("LOGG"+(validacion[name]));
                  (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                  ((validacion[name])[i])[name2] = true;
                  setValidacion({...validacion, [name]: validacion[name]});
                  resp = false;
                }
              //}             
            }
            i++;
          }
          if(name=="contactoRimac" && data[name].length==0){
            validacion[name]=[{nombres: true,
                              apePaterno: true,
                              idpArea: true}];
            setValidacion({...validacion, [name]: validacion[name]});
            resp = false;
          }
        }
        /*if(name=='numDocumento' && !Validate.validarDocumento(data.idpTipoDocumento,data[name])){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
        }*/ 
      //}     
    }
    return resp;
  }


  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);
 

  const handleCloseModal = (value) => {
    setOpenAdd(value);
  };

  const handleChangeEnvioCorreo = (event) => {
    console.log('============', event)
  };

  const handleChangeEmail = (text) => {
    console.log('============', text);
    };


  const handleOpenAddModal = (tag) => {    
    setTagBody(tag);
    resetForm();
    setOpenAdd(true);
  };

  const handleShowModal = (row, tag) => {
    resetForm();
    if (!openAdd) setOpenAdd(true);
    setTagBody(tag);
    if (tag === "edit") fillEditForm(row);
  };

  const fillEditForm = (row)=> {
    console.log(row);
      
  };
  
  const handleCloseAddModal = () => {
    setOpenAdd(false);
  };

  const bodyModalAdd = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">
            Registro para{" "}
            <span className="title-05 color-red">
              <strong>{ tagBody=="add" && ("agregar nueva") } { tagBody=="edit" && ("actualizar") } área</strong>
            </span>
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areasLay__formulario--left2Columns">
              <Input label="Nombre de área" />
            </div>
            <div className="usersLay__formulario--right2Columns">
              <Select label="Estado"  />
            </div>
            
        </div>
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areassLay__formulario--left2Columns">
            <Checkbox id="chkEnvioCorreo" label="Envío de Correo" />
            <label htmlFor="chkEnvioCorreo">Enviar correo de notificación</label>
            </div>
          
        </div>
        <br/>
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areassLay__formulario--left2Columns">
            <Checkbox id="chkEnvioCorreoRecepcion" label="Envío de Correo Recepcion" />
            <label htmlFor="chkEnvioCorreoRecepcion">Correo de recepción de factura</label>
            </div>
            
            
        </div>
      
        </div>
      </div>
    );
  };  
    
  const handleClickRegisterModal = async () => {
      //const { dateTimeCreation, docNumber, clientDoc, id } = selectedRow;
    if(tagBody=="add")
    { 
        const body = {
          payload: {
            
          },
        };
        try {
          dispatch(showLoading());
          const response = await callService(
            "POST",
            CONSTANTES.APIS_PATH.insertArea,
            body
          );
          dispatch(hideLoading());
          // type == 0 => ok , type == 1 => error
          let error = response.data? response.data.type:null;
          if (response.ok && response.data && response.ok == true && error!='1') {
            resetForm();
            setShowAlert({
              show: true,
              title: "Correcto",
              message: response.data.data || "Se guardó el registró",
              type: "success",
            });
            resetMessage(5);
            handleCloseModal(false);            
            setCurrentPage(new Number(1));            
          } else {
            const mesaje = response.message || "Error al registrar";
            setShowAlert({
              show: true,
              title: "Error",
              message: mesaje,
              type: "error",
            });
            resetMessage(5);
          }
          // handleSearchEndpoint();
        } catch (ex) {
          console.log(ex)
          dispatch(hideLoading());
        }
      
    }
    
  };

  const handleSearchEndpoint = async () => {
    let payload = {
     
      
      
    };
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.searchArea,
      fetchObj
    );
    dispatch(hideLoading());
    if (response.ok && response.data) {
      let { totalPages } = response.data;
      setPaginationData({ ...paginationData, totalPages: totalPages });

      let arrData =
        response &&
        response.data &&
        response.data.rows &&
        response.data.rows.map((item) => {
          let obj = {
            id: item.ID,
            dateTimeCreation: item.dateTimeCreation,
            name: item.name,
            email: item.email,
            emailRecepcion: item.emailRecepcion,
            estado: item.estado,
            sendMailValidation:  item.sendMailValidation? item.sendMailValidation: false,
            valEmailRecepcion:  item.valEmailRecepcion? item.valEmailRecepcion: false  
          };
          return obj;
        });
    } else {
      console.log("Error fetching data => ", response.message);
      
    }
  };

  return (
    <div className="step__content" data-key={keyIndex}>
        <div className="proveedores_content">
            <h4 className="title-05 margin-bottom-16 margin-top-16">
                <p><b>Contactos de <span class="title-red">Rimac</span></b> </p>
                <p className="title-06"><b>Cuéntenos quienes son las personas de contacto de Rimac:</b></p>
            </h4> 
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Nombres"
                    name="nombres"
                    maxLength="200"
                    value={(data && data.contactoRimac[0] && data.contactoRimac[0].nombres) || ''}
                    onChange={(newValue) => {(data.contactoRimac[0]||(data.contactoRimac[0]={})).nombres = newValue;                                                  
                                            handleChange("contactoRimac", data.contactoRimac, 0);
                                            }
                    }
                    hasError= {(validacion.contactoRimac[0]  && validacion.contactoRimac[0].nombres) && '*'}
                    customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/} 
                  />
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Apellido Paterno"
                    name="apePaterno"
                    maxLength="500"
                    value={(data && data.contactoRimac[0] && data.contactoRimac[0].apePaterno) || ''}
                    onChange={(newValue) => {(data.contactoRimac[0]||(data.contactoRimac[0]={})).apePaterno = newValue;                                                  
                                            handleChange("contactoRimac", data.contactoRimac, 0);
                                            }
                    }
                    hasError= {(validacion.contactoRimac[0]  && validacion.contactoRimac[0].apePaterno) && '*'}
                    customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/} 
                  />
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Input
                    label="Apellido Materno"
                    name="apeMaterno"
                    maxLength="500"
                    value={(data && data.contactoRimac[0] && data.contactoRimac[0].apeMaterno) || ''}
                    onChange={(newValue) => {(data.contactoRimac[0]||(data.contactoRimac[0]={})).apeMaterno = newValue;                                                  
                                            handleChange("contactoRimac", data.contactoRimac, 0);
                                            }
                    }
                    hasError= {(validacion.contactoRimac[0]  && validacion.contactoRimac[0].apeMaterno) && '*'}
                    customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/} 
                  />
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                    <Select
                      label="Area"
                      selected={(data && data.contactoRimac[0] && arrArea.find(obj=>obj.value==data.contactoRimac[0].idpArea))}
                      onChange={(newValue) => {(data.contactoRimac[0]||(data.contactoRimac[0]={})).idpArea = newValue.value;
                                                handleChange("contactoRimac", data.contactoRimac, 0); 
                                                }
                      }
                      items={arrArea}
                      hasError= {(validacion.contactoRimac[0]  && validacion.contactoRimac[0].idpArea) && '*'}
                    />
              </div>
            </div>                  
            <h4 className="title-06 margin-bottom-16 margin-top-48">
                Agregar mas personas de contacto en Rimac:
            </h4> 
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_datos">
                  <Tab
                  activeTab={0}
                  options={"Contacto Adicional 1|Contacto Adicional 2"}
                  //changeTab={tabQuestions}
                  //disabledTab={tabDisabled}
                  contents={
                  <>
                  <div className="tab__content is-active" data-key={0}>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Nombres"
                          name="nombres"
                          maxLength="1000"
                          value={(data && data.contactoRimac[1] && data.contactoRimac[1].nombres) || ''}
                          onChange={(newValue) => {(data.contactoRimac[1]||(data.contactoRimac[1]={})).nombres = newValue;                                                  
                                                  handleChange("contactoRimac", data.contactoRimac, 1);
                                                  }
                          }
                          hasError= {(validacion.contactoRimac[1]  && validacion.contactoRimac[1].nombres) && '*'}
                          customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Apellido Paterno"
                          name="apePaterno"
                          maxLength="1000"
                          value={(data && data.contactoRimac[1] && data.contactoRimac[1].apePaterno) || ''}
                          onChange={(newValue) => {(data.contactoRimac[1]||(data.contactoRimac[1]={})).apePaterno = newValue;                                                  
                                                  handleChange("contactoRimac", data.contactoRimac, 1);
                                                  }
                          }
                          hasError= {(validacion.contactoRimac[1]  && validacion.contactoRimac[1].apePaterno) && '*'}
                          customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Apellido Materno"
                          name="apeMaterno"
                          maxLength="1000"
                          value={(data && data.contactoRimac[1] && data.contactoRimac[1].apeMaterno) || ''}
                          onChange={(newValue) => {(data.contactoRimac[1]||(data.contactoRimac[1]={})).apeMaterno = newValue;                                                  
                                                  handleChange("contactoRimac", data.contactoRimac, 1);
                                                  }
                          }
                          hasError= {(validacion.contactoRimac[1]  && validacion.contactoRimac[1].apeMaterno) && '*'}
                          customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                      <Select
                        label="Area"
                        selected={(data && data.contactoRimac[1] && arrArea.find(obj=>obj.value==data.contactoRimac[1].idpArea))}
                        onChange={(newValue) => {(data.contactoRimac[1]||(data.contactoRimac[1]={})).idpArea = newValue.value;
                                                  handleChange("contactoRimac", data.contactoRimac, 1); 
                                                  }
                        }
                        items={arrArea}
                        hasError= {(validacion.contactoRimac[1]  && validacion.contactoRimac[1].idpArea) && '*'}
                      />
                    </div>                          
                  </div>
                  <div className="tab__content" data-key={1}>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Nombres"
                          name="nombres"
                          maxLength="1000"
                          value={(data && data.contactoRimac[2] && data.contactoRimac[2].nombres) || ''}
                          onChange={(newValue) => {(data.contactoRimac[2]||(data.contactoRimac[2]={})).nombres = newValue;                                                  
                                                  handleChange("contactoRimac", data.contactoRimac, 2);
                                                  }
                          }
                          hasError= {(validacion.contactoRimac[2]  && validacion.contactoRimac[2].nombres) && '*'}
                          customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Apellido Paterno"
                          name="apePaterno"
                          maxLength="1000"
                          value={(data && data.contactoRimac[2] && data.contactoRimac[2].apePaterno) || ''}
                          onChange={(newValue) => {(data.contactoRimac[2]||(data.contactoRimac[2]={})).apePaterno = newValue;                                                  
                                                  handleChange("contactoRimac", data.contactoRimac, 2);
                                                  }
                          }
                          hasError= {(validacion.contactoRimac[2]  && validacion.contactoRimac[2].apePaterno) && '*'}
                          customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                        <Input
                          label="Apellido Materno"
                          name="apeMaterno"
                          maxLength="1000"
                          value={(data && data.contactoRimac[2] && data.contactoRimac[2].apeMaterno) || ''}
                          onChange={(newValue) => {(data.contactoRimac[2]||(data.contactoRimac[2]={})).apeMaterno = newValue;                                                  
                                                  handleChange("contactoRimac", data.contactoRimac, 2);
                                                  }
                          }
                          hasError= {(validacion.contactoRimac[2]  && validacion.contactoRimac[2].apeMaterno) && '*'}
                          customRegex={/^[a-zA-Z0-9\s\u00f1\u00d1]*$/}
                        />
                    </div>
                    <div className="documents_criteria_datostab">
                      <Select
                          label="Area"
                          selected={(data && data.contactoRimac[2] && arrArea.find(obj=>obj.value==data.contactoRimac[2].idpArea))}
                          onChange={(newValue) => {(data.contactoRimac[2]||(data.contactoRimac[2]={})).idpArea = newValue.value;
                                                    handleChange("contactoRimac", data.contactoRimac, 2); 
                                                    }
                          }
                          items={arrArea}
                          hasError= {(validacion.contactoRimac[2]  && validacion.contactoRimac[2].idpArea) && '*'}
                        />
                    </div>
                  </div>
                  </>
                  }
                  >
                  </Tab>
              </div>
            </div>
            <div className="d-justify-space-between d-flex-column-m w100">
              <div className="documents_criteria_btns d-flex-end margin-bottom-16">
                <div className="documents_btnSearch">
                  <Button
                    // type="submit"
                    primary
                    size="large"
                    onClick={()=>{
                      if(validarFormulario())
                      {
                        handleActualizarFicha(data);
                        handleChangePaso(keyIndex);
                      }
                    }}
                  >
                    Continuar
                  </Button>
                </div>                  
              </div>
            </div>
        </div>
        <div className="proveedores_margen">
            <DatosProveedor data={dataT}/>       
        </div>
    </div>
  );
};


export default ProveedoresContactoRimac;
